'use client';

import { __assign } from '../_virtual/_tslib.js';
import React__default, { useState, useEffect } from 'react';
import Input from '../Input/index.js';
import { DEFAULT_OPTION } from './constants.js';
import { InputYOEWrapper, Label, InputWrapper, Postfix, ErrorMessage } from './InputYOE.css.js';

var InputYOE = function (props) {
    var labelText = props.labelText, isRequired = props.isRequired, _a = props.isError, isError = _a === void 0 ? false : _a, _b = props.errorText, errorText = _b === void 0 ? '' : _b, postfixText = props.postfixText, _c = props.defaultValue, defaultValue = _c === void 0 ? '' : _c, _d = props.placeholder, placeholder = _d === void 0 ? '' : _d, _e = props.typeInput, typeInput = _e === void 0 ? 'number' : _e, options = props.options, onChange = props.onChange, onFocus = props.onFocus, _f = props.thinLabel, thinLabel = _f === void 0 ? false : _f;
    var mergedOptions = __assign(__assign({}, DEFAULT_OPTION), options);
    var _g = useState(''), value = _g[0], setValue = _g[1];
    var onChangeValue = function (value) {
        var parsedValue = Number(value);
        if (value === '' && mergedOptions.canBeEmpty) {
            setValue('');
            onChange && onChange(value);
            return;
        }
        if (parsedValue < mergedOptions.min) {
            return;
        }
        if (parsedValue > mergedOptions.max) {
            return;
        }
        setValue(value);
        onChange && onChange(value);
    };
    useEffect(function () {
        setValue(defaultValue);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultValue]);
    return (React__default.createElement(InputYOEWrapper, null,
        labelText ? (React__default.createElement(Label, { thinLabel: thinLabel },
            isRequired && React__default.createElement("span", null, "*"),
            labelText)) : null,
        React__default.createElement(InputWrapper, { isError: isError, typeInput: typeInput },
            React__default.createElement(Input, __assign({}, props, { type: 'number', value: value.toString(), min: mergedOptions.min, max: mergedOptions.max, numberFieldRule: 'positive-int' // No 'e', no float, no negative integer
                , placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : '', onFocus: function () { return onFocus && onFocus(); }, onChange: onChangeValue })),
            React__default.createElement(Postfix, null, postfixText)),
        isError && errorText ? (React__default.createElement(ErrorMessage, { fontSize: mergedOptions.fontSizeErrorText || 12 }, errorText)) : (React__default.createElement(React__default.Fragment, null))));
};

export { InputYOE as default };
//# sourceMappingURL=index.js.map
